export default ({
  allowEmpty,
  alwaysOn,
  basePath,
  component,
  defaultValue,
  formClassName,
  initializeForm,
  input,
  isRequired,
  label,
  limitChoicesToValue,
  locale,
  meta,
  options,
  optionText,
  optionValue,
  source,
  textAlign,
  translate,
  translateChoice,
  ...rest
}) => rest
